import axiosApi from '@/lib/axios';
import cmsApi from '@/lib/cms';

const homePage = {
    namespaced: true,
    strict: false,
    state: {
        home: [],
        banners: [],
        newsTicker: [],
        newsTickerLists: [],
        latestNews: [],
        pojokKebijakan: [],
        opiniInsan: [],
        info: [],
        menu: [],
        footerTautan: [],
        footerKontak: [],
        footerCountlayananJf: [],
        user: null,
        token: null,
    },
    mutations: {
        SET_HOME(state, payload) {
            state.home = payload
        },
        SET_HOME_INFO(state, payload) {
            state.info = payload
        },
        SET_BANNERS(state, payload) {
            state.banners = payload
        },
        SET_NEWS_TICKER(state, payload) {
            state.newsTicker = payload
        },
        SET_NEWS_TICKER_LISTS(state, payload) {
            state.newsTickerLists = payload
        },
        SET_HOME_LATESTNEWS(state, payload) {
            state.latestNews = payload
        },
        SET_HOME_POJOK_KEBIJAKAN(state, payload) {
            state.pojokKebijakan = payload
        },
        SET_HOME_OPIN_INSAN(state, payload) {
            state.opiniInsan = payload
        },
        SET_MENU(state, payload) {
            state.menu = payload
        },
        SET_FOOTER_TAUTAN(state, payload) {
            state.footerTautan = payload
        },
        SET_FOOTER_KONTAK(state, payload) {
            state.footerKontak = payload
        },
        SET_FOOTER_COUNT_LAYANAN_JF(state, payload) {
            state.footerCountlayananJf = payload
        },
        SET_USER(state, payload) {
            state.user = payload.user
            state.token = payload.token
        },
    },
    actions: {
        getBanners({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/banner')
                    .then((response) => {
                        commit('SET_BANNERS', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getNewsTicker({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/news-ticker')
                    .then((response) => {
                        commit('SET_NEWS_TICKER', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getNewsTickerLists({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/news-ticker-lists')
                    .then((response) => {
                        commit('SET_NEWS_TICKER_LISTS', response.data.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getLatestNews({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/latest-news')
                    .then((response) => {
                        commit('SET_HOME_LATESTNEWS', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getLatestPojokKebijakan({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/latest-pojok-kebijakan')
                    .then((response) => {
                        commit('SET_HOME_POJOK_KEBIJAKAN', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getLatestOpiniInsan({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/latest-opini-insan')
                    .then((response) => {
                        commit('SET_HOME_OPIN_INSAN', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },

        getMenu({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('menu')
                    .then((response) => {
                        commit('SET_MENU', response.data.data)
                        resolve(response.data)
                    })
                    .catch(err => reject(err))
            })
        },

        getGlobalInfo({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page/info')
                    .then((response) => {
                        commit('SET_HOME_INFO', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getHomePages({ commit }) {
            return new Promise((resolve, reject) => {
                return axiosApi.get('home-page')
                    .then((response) => {
                        commit('SET_HOME', response.data.data)
                        resolve(response.data)
                    })
                    .catch((error) => {
                        //reject(error)
                    })
            })
        },
        getFooterTautan({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await axiosApi.get('home-page/footer/tautan')
                    commit('SET_FOOTER_TAUTAN', res.data.data)
                    resolve(res.data)
                } catch (err) {
                    reject(err)
                }
            })
        },
        getFooterCountLayanan({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await axiosApi.post('home-page/footer/count-layanan-footer')
                    commit('SET_FOOTER_COUNT_LAYANAN_JF', res.data)
                    resolve(res.data)
                } catch (err) {
                    reject(err)
                }
            })
        },
        getFooterKontak({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await axiosApi.get('home-page/footer/kontak')
                    commit('SET_FOOTER_KONTAK', res.data.data)
                    resolve(res.data)
                } catch (err) {
                    reject(err)
                }
            })
        },
        sendSaran({ _ }, payload) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await axiosApi.post('saran', payload)
                    resolve(res.data)
                } catch (err) {
                    reject(err)
                }
            })
        },
        checkRecaptcha(_, payload) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await cmsApi.post('recaptcha', payload);
                    resolve(response.data);
                } catch (error) {
                    reject(error);
                }
            })
        },
    }
};

export default homePage